export const AthenaLogo = () => (
  <img
    src="/next-assets/images/logos/athena-logo-only.svg"
    alt="Athena Logo"
    width="77px"
    height="67px"
    loading="lazy"
  />
);
